<template>
  <div class="container">
    <div id="scroller-wrapper" data-scrollbar>
      <Banner @downclickhandler="downClickHandler" id="top" :list="banner" />
      <div ref="secondscreen" class="secondscreen"></div>
      <About @downclickhandler2="downClickHandler2" id="about" class="about" />
      <div ref="secondscreen2" class="secondscreen"></div>
      <Pro :list="products" :swiperOptiona="swiperOptiona" class="about" ref="pro"/>
      <!-- <News :list="news" class="about" /> -->
      <div class="sbimg wow fadeInUp">
        <img
          v-for="(item, index) in partner"
          :key="index"
          :src="`http://ys.sansg.com/${item.picurl}`"
          alt
        />
      </div>
      <FootCompoents @transferTop="toTop" />
    </div>
  </div>
</template>

<script>
import Scrollbar from "smooth-scrollbar";
import Banner from "../components/banner";
import About from "../components/about";
import Pro from "../components/pro";
import News from "../components/news";
import FootCompoents from "../components/foot";
import { WOW } from "wowjs";
import { getIndex } from "../util/lang";
import "../common/jquery-1.11.3.min.js";
export default {
  data() {
    return {
      wow: "",
      scrollbar: "",
      banner: [],
      products: [],
      partner: [],
      news: [],
      swiperOptiona: {
        slidesPerView: 3, //一行显示3个
        speed: 1000,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        spaceBetween: 80,
        navigation: {
          prevEl: ".con .btn .prev",
          nextEl: ".con .btn .next",
        },
        breakpoints: {
          1000:{
            slidesPerView: 2,
            spaceBetween:10
          }
        },
        pagination: {
          el: ".con .swiper-pagination",
          type: "custom",
          renderCustom: function (swiper, current, total) {
            return "0" + current + " / " + "0" + total;
          },
        },
      },
    };
  },
  components: { Banner, About, Pro, News, FootCompoents },
  mounted() {
    
    this.$nextTick(() => {
      this.getIndex();
      this.wow = new WOW();
      this.init();
      this.swiperOptiona.autoplay = false;
    });
  },
  methods: {
    downClickHandler2() {
      const secondscreen = this.$refs.secondscreen2;
      var secondscreenTop = secondscreen.offsetTop;
      this.scrollbar.scrollTo(
        0,
        secondscreenTop - this.$store.state.topHeight,
        600
      );
    },
    downClickHandler() {
      const secondscreen = this.$refs.secondscreen;
      var secondscreenTop = secondscreen.offsetTop;
      this.scrollbar.scrollTo(
        0,
        secondscreenTop - this.$store.state.topHeight,
        600
      );
    },
    getIndex() {
      const url = `${getIndex(this.$i18n.locale)}`;
      this.$axios.post(url).then((res) => {
        this.banner = res.data.banner;
        this.products = res.data.products;
        this.partner = res.data.partner;
        this.news = res.data.news;
      });
    },
    init() {
      this.$nextTick(() => {
        this.scrollbar = Scrollbar.init(
          document.getElementById("scroller-wrapper")
        );
        var width = document.documentElement.clientWidth;
        if (width > 1000) {
          this.scrollbar.addListener(() => {
            if ($(window).scrollTop() >= 1600) {
              console.log(1)
              this.swiperOptiona.autoplay = {delay: 2000,disableOnInteraction: false}

              // console.log(222)
            }
            $(".about").each(function() {
              var _this = $(this);
              if (
                $(window).scrollTop() >=
                $(this).offset().top - $(window).height() + 400
              ) {
                // console.log('aaa')
                _this.addClass("show");
              } else {
                _this.removeClass("show");
              }
            });
            window.pageYOffset = this.scrollbar.scrollTop;
          });
        } else {
          $(".about").each(function() {
            $(this).addClass("show");
          });
        }

        this.wow.init();
        let scrollbar = Scrollbar.get(
          document.getElementById("scroller-wrapper")
        );
        scrollbar.scrollTo(0, 0);
        window.pageYOffset = this.scrollbar.scrollTop;
        this.scrollbar.addListener(() => {
          this.wow.scrollHandler();
          window.pageYOffset = this.scrollbar.scrollTop;
        });
      });
    },
    toTop(msg) {
      this.top = msg;
      Scrollbar.get(document.getElementById("scroller-wrapper")).scrollIntoView(
        document.querySelector("#top")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.about,
.pro,
.news {
  opacity: 0;
  transition: all 2s;
  transform: translateY(30px);
}
.secondscreen {
  opacity: 0;
  visibility: hidden;
  height: 0;
}
.show {
  opacity: 1;
  transform: translateY(0);
}
.sbimg {
  width: 80%;
  margin: 45px auto;
  display: flex;
  justify-content: space-between;
  img {
    width: 13%;
    display: block;
    object-fit: contain;
    cursor: pointer;
    transition: all 600ms;
    &:hover {
      transform: scale(1.1);
    }
  }
}
@media screen and (max-width: 1000px) {
  .sbimg {
    flex-wrap: wrap;
    justify-content: unset;
    margin: 20px auto;
    img {
      width: 30%;
      margin: 0 1%;
      margin-bottom: 10px;
    }
  }
}
</style>
